module.exports = __webpack_public_path__ + "media/images/zoom2-7e32c82e58993a27cc0041d4047102ac.jpg";